import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromReviewBoard from '@store/reducers/review-board/review-board.reducer';

export const selectReviewBoardState = createFeatureSelector<fromReviewBoard.State>(
  fromReviewBoard.reviewBoardFeatureKey
);

export const selectReviewBoardList = createSelector(
  selectReviewBoardState,
  (state) => state.list
);

export const selectReviewBoardListLoading = createSelector(
  selectReviewBoardState,
  (state) => state.isListLoading
);

export const selectReviewBoardStatus = createSelector(
  selectReviewBoardState,
  (state) => state.status
);

export const selectReviewBoardStatusLoading = createSelector(
  selectReviewBoardState,
  (state) => state.isStatusLoading
);

export const selectReviewBoardSaving = createSelector(
  selectReviewBoardState,
  (state) => state.isSaving
);
